import { render, staticRenderFns } from "./SOCWizard.vue?vue&type=template&id=34585799&"
import script from "./SOCWizard.vue?vue&type=script&lang=js&"
export * from "./SOCWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports